export default __webpack_public_path__ + "static/media/mobile_login_image_uk.3ab1d405.png";